import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';

import { ActiveModal } from '@frontend/sports/modal/feature';
import { DeviceService } from '@frontend/vanilla/core';
import { Store } from '@ngrx/store';
import { Subscription, distinctUntilChanged, filter, tap } from 'rxjs';

import { IBetslipRootState } from '../../../base/store/state';
import { OverAskFlowState } from '../../../model/over-ask/over-ask';
import { overAskStateSelector } from '../selectors';
import { OverAskMessagesProvider } from '../services/over-ask-messages.provider';
import { OverAskTrackingActions } from '../tracking.actions';

@Component({
    selector: 'bs-over-ask-reject-offer-dialog',
    templateUrl: 'betslip-over-ask-reject-offer-dialog.component.html',
    styleUrls: ['./betslip-over-ask-reject-offer-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BetslipOverAskRejectOfferDialogComponent implements OnInit, OnDestroy {
    vm = {
        seconds: 0,
        isTimerVisible: false,
    };

    messages: {
        title: string;
        content: string;
        dismiss: string;
        cancelOffer: string;
        reviewOfferExpires: string;
    };

    private subscription: Subscription | undefined;
    isMobile = false;

    constructor(
        private activeModal: ActiveModal,
        private store: Store<IBetslipRootState>,
        private changeDetector: ChangeDetectorRef,
        private overAskMessagesProvider: OverAskMessagesProvider,
        public deviceService: DeviceService,
    ) {
        this.messages = {
            title: overAskMessagesProvider.messages.reviewRejectDialogTitle,
            content: overAskMessagesProvider.messages.reviewRejectDialogContent,
            dismiss: overAskMessagesProvider.messages.reviewRejectDialogDismissButton,
            cancelOffer: overAskMessagesProvider.messages.rejectDialogCancelButton,
            reviewOfferExpires: overAskMessagesProvider.messages.reviewOfferExpires,
        };
    }

    ngOnInit(): void {
        this.isMobile = this.deviceService.isMobile;
        this.subscription = this.store
            .select(overAskStateSelector)
            .pipe(
                filter((overAskState) => overAskState.flowState === OverAskFlowState.Pending || overAskState.flowState === OverAskFlowState.Review),
                tap((overAskState) => {
                    this.vm = {
                        seconds: overAskState.reviewState.remainingSeconds,
                        isTimerVisible: overAskState.flowState === OverAskFlowState.Review,
                    };

                    this.changeDetector.markForCheck();
                }),
                distinctUntilChanged(),
            )
            .subscribe((overAskState) => {
                if (overAskState.flowState === OverAskFlowState.Pending) {
                    this.messages.title = this.overAskMessagesProvider.messages.pendingRejectDialogTitle;
                    this.messages.content = this.overAskMessagesProvider.messages.pendingRejectDialogContent;
                    this.messages.dismiss = this.overAskMessagesProvider.messages.pendingRejectDialogDismissButton;
                    this.messages.cancelOffer = this.overAskMessagesProvider.messages.rejectDialogCancelButton;
                }
                this.changeDetector.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    onReturnBack(): void {
        this.store.dispatch(OverAskTrackingActions.trackRejectDialogActionDismiss());
        this.activeModal.close('RETURN');
    }

    onCancelConfirm(): void {
        this.store.dispatch(OverAskTrackingActions.trackRejectDialogActionCancel());
        this.activeModal.close('CANCEL');
    }
}
